import React from 'react';
export function LoadingPage() {
  return (
    <div className='flex flex-col items-center justify-center w-screen h-screen'>
      <span className='loading loading-infinity text-red-400 w-16'></span>
    </div>
  );
}
